// in src/fields.js
import {
  Create,
  Datagrid,
  DisabledInput,
  Edit,
  EditButton,
  EmailField,
  Filter,
  List,
  SelectInput,
  SimpleForm,
  TextField,
  TextInput
} from 'admin-on-rest/lib/mui';
import { ShowButton } from 'admin-on-rest/lib/mui/button';
import { Show, SimpleShowLayout } from 'admin-on-rest/lib/mui/detail';
import React from 'react';
import UserProjectsField from './components/UserProjectsField';

const ROLES = [
  { id: 'admin', name: 'admin' },
  { id: 'customer', name: 'customer' },
  { id: 'agent', name: 'agent' },
  { id: 'user', name: 'user' }
];

const UserFilter = props => (
  <Filter {...props}>
    <TextInput label="Search" source="email" alwaysOn />
    <SelectInput source="role" choices={ROLES} />
  </Filter>
);
export const UserList = props => (
  <List title="All users" {...props} filters={<UserFilter />}>
    <Datagrid>
      <TextField source="id" />
      <TextField source="firstName" />
      <TextField source="lastName" />
      <EmailField source="email" />
      <EmailField source="username" />
      <TextField source="role" />
      <ShowButton />
      <EditButton />
    </Datagrid>
  </List>
);

const UserTitle = ({ record }) => {
  return <span>User {record ? `"${record.fullName}"` : ''}</span>;
};

export const UserEdit = props => (
  <Edit title={<UserTitle />} {...props}>
    <SimpleForm>
      <DisabledInput source="id" />
      <DisabledInput source="email" />
      <DisabledInput source="username" />
      <TextInput source="password" type="password" />
      <TextInput source="firstName" />
      <TextInput source="lastName" />
      <SelectInput source="role" choices={ROLES} />
      <UserProjectsField label="Projects" />
    </SimpleForm>
  </Edit>
);

export const UserCreate = props => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="email" type="email" />
      <TextInput source="username" />
      <TextInput source="password" type="password" />
      <TextInput source="firstName" />
      <TextInput source="lastName" />
      <SelectInput source="role" choices={ROLES} />
    </SimpleForm>
  </Create>
);

export const UserShow = props => (
  <Show title={<UserTitle />} {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="email" />
      <TextField source="username" />
      <TextField source="firstName" />
      <TextField source="lastName" />
      <TextField source="role" />
      <UserProjectsField label="Projects" />
    </SimpleShowLayout>
  </Show>
);



// WEBPACK FOOTER //
// ./src/users.js